<template>
  <section class="container search-box">
    <div class="row">
      <div class="col-12 mb-4">
        <h2>
          Kerro, missä viljelet, niin näytämme sinulle tarjolla olevat tuotteet
        </h2>
      </div>
    </div>
    <div class="row search-input">
      <div class="col-12">
        <AutocompleteInput
          key="product-search"
          :loading="loading"
          placeholder="Tuotteen toimitusosoite"
          @selected="getAddress"
        />
      </div>
    </div>
  </section>
</template>

<script>
import AutocompleteInput from "../../shared/components/AutocompleteInput";
import { mapActions, mapMutations } from "vuex";
import { SET_ADDRESS, SET_SELLER, UPDATE_PROFILE } from "../../store/constants";
import { get } from "@vueuse/core";
import { getAddressInfo } from "../../shared/helpers";
export default {
  name: "SearchBox",
  components: { AutocompleteInput },
  emits: ["addressFilter"],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    ...mapMutations({
      setAddress: SET_ADDRESS,
      setSeller: SET_SELLER,
    }),
    ...mapActions({
      updateProfile: UPDATE_PROFILE,
    }),
    getAddress: async function ({ fromEvent, input, autocomplete }) {
      this.error = false;
      this.loading = true;
      const auto = get(autocomplete);
      const place = auto.getPlace();
      const inEl = get(input);
      const locationObject = await getAddressInfo(place, inEl, fromEvent);
      const { placeObject } = locationObject;

      if (!placeObject || (!placeObject.postal_code && !placeObject.locality)) {
        this.error = true;
        this.loading = false;
        return;
      }

      if (inEl.value) placeObject.addressLine = inEl.value;

      placeObject.geometryLocation = locationObject.geometryLocation;

      const updateResult = await this.updateProfile({
        placeObject,
        ignoreSellerError: true,
      });

      if (!updateResult) {
        this.error = true;
        this.loading = false;
        return;
      }

      this.$emit("addressFilter");

      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
section.search-box {
  padding: 2rem 3rem;
  background-color: var(--bs-yellow);
  text-align: center;
  .search-input:deep(.autocomplete-input) {
    input {
      // text-align: center;
    }
  }
}
</style>
